import { useCallback, useEffect } from "react";

/**
 * Enables capturing the Escape key
 */
export const useEscapeShortcut = (setTriggered: (value: boolean) => void) => {
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key !== "Escape") {
                return;
            }

            // to not interfere with the things like modal dismissals
            if (event.defaultPrevented) {
                return;
            }
            event.preventDefault();
            setTriggered(true);
        },
        [setTriggered],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);
};
